import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import Breadcrumb from "../Breadcrumb";
import Modal from "../Modal/Modal";
import { logoutUser } from "../../actions/user";
import "./AdminUpdatePassword.css";

const AdminUpdatePassword = ({
    isFetching, 
    user_info,
    fetchUserInfo,
    updateAdminPassword,
    password_otp_enable,
    password_session_id
}) => {

  const { adminId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [form, setForm] = useState({
      old_password: "",
      new_password: "",
      confirm_password: "",
      otp: "",
  });
  
  const [showNewPw, setShowNewPw] = useState(false);
  const [showConfirmPw, setShowConfirmPw] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMsg, setModalMsg] = useState("");

  useEffect(() => {
    fetchUserInfo();
  // eslint-disable-next-line
  }, [adminId]);

  //OTP入力欄を初期化する
  useEffect(() => {
    if (password_otp_enable === 1) {
      setForm((prev) => ({ ...prev, otp: "" }));
    }
  }, [password_otp_enable]);

  const onChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  //パスワード変更実行
  const handleUpdate = async () => {
    // Basic validation
    if (!form.old_password || !form.new_password || !form.confirm_password) {
      setModalMsg("すべての項目を入力してください。");
      setModalOpen(true);
      return;
    }

    if (form.new_password !== form.confirm_password) {
      setModalMsg("新しいパスワードが一致しません。");
      setModalOpen(true);
      return;
    }

    if (form.old_password === form.new_password) {
      setModalMsg("新しいパスワードは現在のパスワードと異なるものを設定してください。");
      setModalOpen(true);
      return;
    }

    // Build request body
    const body = {
      admin_id: adminId,
      password_old: form.old_password,
      password_new: form.new_password,
    };

    // If OTP already required → add session + otp
    if (password_otp_enable === 1 && password_session_id) {
      body.session_id = password_session_id;
      body.otp = form.otp;
    }

    const res = await updateAdminPassword(body);

    // OTP enabled → server tells us to wait for user OTP
    if (res?.payload?.otp_enable === 1) {
      setModalMsg("認証コードをメールに送信しました。");
      setModalOpen(true);
      return;
    }

    // Success
    if (res?.payload?.success === 1) {
      setModalMsg("パスワード変更が完了しました");
      setModalOpen(true);
      return;
    }

    // Error
    if (res?.error) {
      setModalMsg(res.error);
      setModalOpen(true);
    }

  };

  return (
    <div id="Main">
      <div id="Contents">
        <Breadcrumb 
          user={user_info?.admin_name}
          onLogout={() => dispatch(logoutUser())} 
        />

        {modalOpen && (
          <Modal
            isOpen={modalOpen}
            onClose={() => setModalOpen(false)}
            message={modalMsg}
          />
        )}

        <div className="admin-layout">
          <div className="admin-card">
            <h2 className="admin-title">パスワードの変更</h2>

            {/* Buttons */}
            <div className="password-btn-row">
              <button className="btn-update" onClick={handleUpdate}>変更</button>
              <button className="btn-back" onClick={() => navigate(-1)}>戻る</button>
            </div>

            {/* Form */}
            <div className="password-form-box">
              
              <div className="pw-row">
                <label>元のパスワード</label>
                <input
                  type="password"
                  name="old_password"
                  value={form.old_password}
                  onChange={onChange}
                />
              </div>

              <div className="pw-row">
                <label>新しいパスワード</label>
                <div className="password-wrapper">
                  <input
                    type={showNewPw ? "text" : "password"}
                    name="new_password"
                    value={form.new_password}
                    onChange={onChange}
                  />
                  <span className="toggle-password" onClick={() => setShowNewPw(!showNewPw)}>
                    <img
                      src={showNewPw ? "/img/common/show-password.svg" : "/img/common/hidden-password.svg"}
                      alt="toggle"
                      className="toggle-password-icon"
                      />
                  </span>
                </div>
              </div>

              <div className="pw-row">
                <label>新しいパスワード（確認用）</label>
                <div className="password-wrapper">
                  <input
                    type={showConfirmPw ? "text" : "password"}
                    name="confirm_password"
                    value={form.confirm_password}
                    onChange={onChange}
                  />
                  <span className="toggle-password" onClick={() => setShowConfirmPw(!showConfirmPw)}>
                    <img
                      src={showConfirmPw ? "/img/common/show-password.svg" : "/img/common/hidden-password.svg"}
                      alt="toggle"
                      className="toggle-password-icon"
                      />
                  </span>
                </div>

              </div>

              {/* OTP input (appear only if server says so) */}
              {password_otp_enable === 1 && (
                <div className="pw-row">
                  <label>認証コード</label>
                  <input
                    name="otp"
                    value={form.otp}
                    onChange={onChange}
                  />
                </div>
              )}

            </div>
          </div>
        </div>
      </div>

      {/* Overlay loading */}
      <div className={`overlay ${isFetching ? "active" : ""}`}>
        <div className={`spinner ${isFetching ? "active" : ""}`}></div>
      </div>
    </div>
  );
};

export default AdminUpdatePassword;
